import { Redirect } from "expo-router";
import { ActivityIndicator } from "react-native";

import { CenteredScreen } from "~/components/ui";
import { useAuth } from "~/hooks/useAuth";
import { useWorkspaceSwitcher } from "~/hooks/workspace";
import { getPostAuthPath } from "~/utils/onboarding";

export default function Index() {
  const { session, user, loading, passwordRecoveryActive } = useAuth();
  const workspaces = useWorkspaceSwitcher();
  const hasSharedWorkspace = workspaces.workspaces.some(
    (workspace) => workspace.owner_id !== user?.id,
  );

  if (loading || (session?.user && workspaces.isLoading)) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  if (passwordRecoveryActive) {
    return <Redirect href="/reset-password" />;
  }

  if (!session?.user) {
    return <Redirect href="/login" />;
  }

  return (
    <Redirect href={getPostAuthPath(user, { hasSharedWorkspace }) as never} />
  );
}
